import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {MenuItem} from "primeng/api";
import {ContractService} from "../../../../service/api/contract.service";
import {WidgetData} from "../../../../../../core/shared/widget/widget-data";
import {OverviewDto} from "../../../../../../core/shared/overview/dto/overview.dto";
import {MvsCoreService} from "../../../../../../core/shared/service/mvs-core.service";
import {ObjectRequestListGroupBy} from "../../../../../../core/shared/dto/object/request/object-request-list-group-by";
import {
    ObjectRequestListAttribute
} from "../../../../../../core/shared/dto/object/request/object-request-list-attribute";
import {
    ObjectRequestEntityProcessingTypeEnum
} from "../../../../../../core/shared/dto/object/request/object-request-entity-processing-type.enum";
import {EntityStatusEnum} from "../../../../../../core/shared/entity/enum/entity-status.enum";
import {WidgetFactory} from "../../../../../../core/shared/widget/service/widget.factory";
import {WidgetDataParam} from "../../../../../../core/shared/widget/widget-data-param";
import {DatesHelper} from "../../../../../../core/shared/helper/dates-helper";
import {FilterCriteria} from "../../../../../../core/shared/filter/api/filter.criteria";
import {Sorting} from "../../../../../../core/shared/misc/sorting";
import {
    DtoListAttributeRequestAggregateEnum
} from "../../../../../../core/shared/dto/enum/dto-list-attribute-request-aggregate.enum";
import {
    OverviewStatisticsBaseComponent
} from "../../../../../../core/shared/overview/overview-statistics-base.component";

@Component({
    selector: 'cm-statistics-component',
    templateUrl: 'cm-statistics.component.html',
    standalone: false
})
export class CmStatisticsComponent extends OverviewStatisticsBaseComponent implements OnInit, OnChanges, OnDestroy {

    defaultLabel: string = "Contract Overview";

    pendingContracts: number = 0;
    activeContractsThisMonth: number = 0;
    obsoleteContracts: number = 0;
    terminatedContracts: number = 0;
    contractSignedPerMonthWidget: WidgetData;
    contractStatusBreakdownWidget: WidgetData;
    contractExpirationWidget: WidgetData;
    contractsConversion: number;

    items: MenuItem[] | undefined;

    home: MenuItem | undefined;

    overviewDto: OverviewDto[];

    constructor(
        private router: Router,
        protected route: ActivatedRoute,
        protected coreService: MvsCoreService,
        protected contractService: ContractService) {
        super(route, coreService)
    }


    ngOnInit(): void {


        this.items = [
            {label: 'Agent Module'},
        ];

        this.home = {icon: 'pi pi-home', routerLink: '/'};
        super.ngOnInit();
        this.initComponent();
    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {


        this.getContractStatusThisMonth();
        this.refreshContractsSignedPerMonth();
        this.refreshContractExpirationWidget();
        this.refreshContractStatusBreakdownWidget();

        this.initialized = true;

    }

    navigateToConfig() {
        this.router.navigate(['/cm/config']);
    }

    getContractStatusThisMonth() {

        const objectRequestList = ObjectRequestListGroupBy.create(
            false,
            this.filterCriteria,
            [],
            ['entityStatus'],
            [new ObjectRequestListAttribute('entityStatus', "Anzahl", DtoListAttributeRequestAggregateEnum.count)],
            ObjectRequestEntityProcessingTypeEnum.regular
        );

        this.contractService.groupBy(objectRequestList).subscribe(res => {

            this.overviewDto = [
                {label: 'Pending Contracts', value: 0},
                {label: 'Active Contracts', value: 0},
                {label: 'Obsolete Contracts', value: 0},
                {label: 'Terminated Contracts', value: 0}
            ];

            for (let item of res.entries) {
                if (item['entityStatus'] === EntityStatusEnum.draft || item['entityStatus'] === EntityStatusEnum.pending) {
                    this.overviewDto.find(entry => entry.label === 'Pending Contracts').value += item['entityStatus_count'];
                } else if (item['entityStatus'] === EntityStatusEnum.active) {
                    this.overviewDto.find(entry => entry.label === 'Active Contracts').value += item['entityStatus_count'];
                } else if (item['entityStatus'] === EntityStatusEnum.discarded || item['entityStatus'] === EntityStatusEnum.deleted) {
                    this.overviewDto.find(entry => entry.label === 'Terminated Contracts').value += item['entityStatus_count'];
                } else if (item['entityStatus'] === EntityStatusEnum.obsolete) {
                    this.overviewDto.find(entry => entry.label === 'Obsolete Contracts').value += item['entityStatus_count'];
                }
            }

        });

    }


    refreshContractsSignedPerMonth() {

        this.contractSignedPerMonthWidget = WidgetFactory.createWidget(
            'cm.contract.overview.contract.per.month',
            'Contracts Signed per Month ',
            'history.chart',
            'list',
            'entity.groupBy',
            'cm.Contract',
            WidgetDataParam.create("fieldCategory", "group"),
            WidgetDataParam.create("fieldCategoryCount", "group_count"),
            WidgetDataParam.create("historyPeriodMode", "year"),
            WidgetDataParam.create("fieldDate", "startDate"),
            WidgetDataParam.create("selectionMode", "single"),
            WidgetDataParam.create("size", "S")
        );
        this.contractSignedPerMonthWidget.dataProviderListRequest = ObjectRequestListGroupBy.create(
            true,
            this.filterCriteria,
            [],
            ["group", "startDate"],
            [new ObjectRequestListAttribute("group", "Anzahl", DtoListAttributeRequestAggregateEnum.count)]
        );
    }

    refreshContractStatusBreakdownWidget() {
        this.contractStatusBreakdownWidget = WidgetFactory.createWidgetGroupBy(
            'cm.contract.overview.contract.per.month.period',
            'Contracts Status Breakdown',
            'category',
            'entity.groupBy',
            'cm.Contract',
            'entityStatus',
            'entityStatus_count',
            this.filterCriteria,
            'entityStatus',
            'Anzahl');
    }

    refreshContractExpirationWidget() {
        const today = new Date();
        const currentYear = today.getFullYear();
        const currentMonth = today.getMonth() + 1;
        const lastDayOfCurrentMonth = DatesHelper.calculateLastDayOfMonth(currentYear, currentMonth);
        const firstDayOfCurrentMonth = DatesHelper.calculateFirstDayOfCurrentMonth();

        this.contractExpirationWidget = WidgetFactory.createWidgetTableEntityBasicQl('cm.contract.overview.contract.expiration', 'Upcoming Contract Expirations', 'cm.Contract', [FilterCriteria.create('e.plannedEndDate', FilterCriteria.cOperatorBetween, firstDayOfCurrentMonth, lastDayOfCurrentMonth)], [new Sorting('e.plannedEndDate', false)]);
    }


    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
}
